export const META_PIXEL_EVENT_NAMES = {
    PAGE_VIEW: "PageView",
    VIEW_CONTENT: "ViewContent",
    INITIATE_CHECKOUT: "InitiateCheckout",
    PURCHASE: "Purchase",
    COMPLETE_REGISTRATION: "CompleteRegistration",
    LEAD: "Lead",
}
